/* eslint-disable default-case */
import React, { useState, useEffect, useRef, useContext } from 'react'
import IconsPath from '../../assets/icons'
import ParentModal from '../../genericComponents/ParentModal'
import ListComponent from '../../genericComponents/ListComponent'
import { useHistory } from 'react-router-dom'
import { dispatchHandler } from '../../helper/apiHelperFunctions'
import { useDispatch, useSelector } from 'react-redux'
import NotificationModal from './NotificationModal'
import '../../styles/stylesheets/home/Header.scss'
import '../../styles/stylesheets/GenericComponents.scss'
import '../../styles/stylesheets/helper.scss'
import '../../styles/stylesheets/listComponent.scss'
import '../../styles/stylesheets/TableComponent.scss'
import GenericConfirmationModal from '../../genericComponents/GenericConfiramationModal'
import HelpAndSupportDropdownComponent from './HelpAndSupportDropdownComponent'
import HeaderStrip from './components/HeaderStrip'
import EscalationMatrixModal from './components/EscalationMatrixModal'
import ProfileSection from './profileSection/ProfileSection'
import {getNumberOfStrips} from '../../initialPhaseOperations/InitialAnnouncementModal'
import FullPageLoader from '../../loaders/FullPageLoader'
import {getMenuExpandMode, parseJwt } from '../../helper/genericFunction'
import LanguageTranslator from '../../locals/LanguageTranslator'
import NewRegisterVendorDashbaord from '../dashboard/newVendor/NewRegisterVendorDashbaord'
import GenericCustomButton from '../../genericComponents/GenericCustomButton'
import { Tooltip } from 'antd';
import { UserDetailsContext } from '../../App'
import { sendButtonClickEventToGoogleAnalytics } from '../../helper/helperTableFunctions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import UserDataMappingCheck from '../../genericComponents/UserDataMappingCheck'
import { Check, ChevronDown, FileCode2Icon, FileCodeIcon, ListChecks, MessageSquareText, MoveUpRight, Sparkles } from 'lucide-react'
import GenericTabsComponent from '../../genericComponents/GenericTabsComponent'
import { getPermissionKey } from '../../helper/permissions'
import ReplayAppTourModal from './ReplayAppTourModal'
import Icons from '../../assets/icons'
import AppliedFiltersSidebarModal from '../../genericComponents/AppliedFiltersSidebarModal'
import GlobalSearchModal from './GlobalSearchModal.jsx'

const SupplymintHeader = (props) => {
    const STATUS_CLASSNAME_MAP = {
        PENDING: "vsos-pending",
        COMPLETED: "vsos-approved",
        "IN-PROGRESS": "vsos-hold",
        ERROR: "vsos-error"
    };

    const browserLanguage = navigator.language?.slice(0, 2) || navigator.userLanguage?.slice(0, 2);
    let tokenData = parseJwt(sessionStorage.getItem('token'));

    const [selectedModal, setSelectedModal] = useState(false);
    const [refreshListData, setRefreshListData] = useState(false);
    // State: To show and hide the help section dropdown
    const [helpAndSupportDropdown, setHelpAndSupportDropdown] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const generalStore = useSelector(state => state.generalStore);

    const [stripHeight, setStripHeight] = useState(getNumberOfStrips() || 0);
    const [loading, setLoading] = useState(false);
    const [openFiltersDropdown, setOpenFiltersDropdown] = useState(false)
    const [trainingGuideSelectedFilter, setTrainingGuideSelectedFilter] = useState('all')
    const [trainingGuideCurrentTab, setTrainingGuideCurrentTab] = useState(tokenData?.uType?.toUpperCase() || 'ENT')

    const [selectedData, setSelectedData] = useState({});

    const trainingGuideFilterDropdownRef = useRef(null);

    const [openModal, setOpenModal] = useState(false);
    const [openModalData, setOpenModalData] = useState({})
    const [helpAndTrainingConfig, setHelpAndTrainingConfig] = useState([]);
    const [activeTab, setActiveTab] = useState("");


    const OS = navigator?.userAgentData?.platform; // current operating system

    useEffect(() => {
        dispatchHandler(dispatch, "getConfigDataKeyRequest", {key : "FEATURES_VISIBILITY_CONFIG"}, getPermissionKey("common", "commonFunctionality", "view"))
    },[])

    const handleClickOutside = (event) => {
        if (trainingGuideFilterDropdownRef.current && !trainingGuideFilterDropdownRef.current.contains(event.target)) {
            setOpenFiltersDropdown(false); // Close the dropdown if clicked outside
        }
    };
    
    const getConfigDataKeyData = useSelector(state => state?.administrationStore?.getConfigDataKeyData);
   
    useEffect(() => {
        if(getConfigDataKeyData?.isSuccess)
            setHelpAndTrainingConfig(getConfigDataKeyData?.data?.disableConfig || [])
    }, [getConfigDataKeyData?.isSuccess])

    // Initial useEffect Function
    useEffect(() => {
        document.addEventListener("keydown", setHeaderShortcuts);
        document.addEventListener('mousedown', handleClickOutside);

        return (() => {
            document.removeEventListener("keydown", setHeaderShortcuts, false);
            document.removeEventListener('mousedown', handleClickOutside);
        })
    }, []);


    useEffect(() => {
        setInterval(() => {
            setStripHeight(getNumberOfStrips())
        }, 400)
    }, [])

    useEffect(() => {
        setRefreshListData(true);
    }, [generalStore?.["cancelDataExportModalData"]?.isSuccess]);


    useEffect(() => {
        setRefreshListData(false);
    }, [generalStore?.["getDataExportModalData"]?.isSuccess]);

    // Function to handle the shortcuts (keyboard)
    const setHeaderShortcuts = (e) => {

        const ctrlOrCmd = OS === "macOS" ? e.metaKey : e.ctrlKey;

        if (ctrlOrCmd && e.key.toLowerCase() === "k" && !e.shiftKey) {
            e.preventDefault();
            console.log("ctrl k is pressed");
            handleChange("openGlobalSearchModal")();
            setActiveTab(""); // switch to Global Search tab
        }

        if (tokenData?.uType == "ENT" && ctrlOrCmd && e.key.toLowerCase() === "k" && e.shiftKey) {
            e.preventDefault();
            setActiveTab("vendor");
            handleChange("openGlobalSearchModal")();
        }
    }

    // Close Modal function to close the current modal
    const closeModal = () => {
        setSelectedModal(false);
        setTrainingGuideSelectedFilter('all')
    }

    const handleChange = (type, data) => (e) => {
        // Function to handle changes inside the headers component
        console.log("type", type);
        switch (type) {
            case "openGlobalSearchModal": {
                sendButtonClickEventToGoogleAnalytics({
                    label: "Global Search", location : location,
                })
                setSelectedModal("globalSearch");
                break;
            }
            case "goToPage": {
                let temp = {
                    pathname: data.pageUrl?.replace("#", "")
                };
                if (data.pageUrl) {
                    history?.push(temp)
                }
                break;
            }
            case "openDataExportModal": {
                setSelectedModal("dataExportModal");
                break;
            }
            case "cancelItemExport": {
                dispatchHandler(dispatch, "cancelDataExportModalRequest", {
                    id: data?.id || "",
                    status: data?.status || "",
                })
                break;
            }
            case "downloadExportDataFile": {
                if (data?.file_url) {
                    window.open(data.file_url);
                }
                break;
            }
            case "helpAndSupportDropdown": {
                if (helpAndSupportDropdown) {
                    closeHelpModal();
                } else {
                    setHelpAndSupportDropdown(!helpAndSupportDropdown);
                    setTimeout(() => document.addEventListener("click", closeHelpModal), 0)
                }
                break;
            }
        }
    }

    const closeHelpModal = (e) => {
        setHelpAndSupportDropdown(false)
        setTimeout(() => document.removeEventListener("click", closeHelpModal), 0)
    }

    const trainingGuideFilterDropdownData = [
        { label: 'All', value: 'all'},
        { label: 'Image', value: 'image' },
        { label: 'Video', value: 'video' },
        { label: 'Documents', value: 'document' },
        { label: 'Portal Default Media', value: 'systemDefault' },
    ];

    const getChildComponent = () => {
        switch (selectedModal) {
            case "globalSearch":
                return GlobalSearchModal;
            case "trainingGuidesModal":
            case "dataExportModal": {
                return ListComponent;
            }
            case "notificationModal": {
                return NotificationModal;
            }
            case "escalationMatrixModal": {
                return EscalationMatrixModal
            }
            case "confirmationModal": {
                return GenericConfirmationModal
            }
            case "replayAppTourModal": {
                return ReplayAppTourModal;
            }
        }
    }

    const {userDetails} = useContext(UserDetailsContext);

    const getParentChildProps = () => {
        let payload = {
            closeModal: closeModal
        }
        switch (selectedModal) {
            case "globalSearch": {
                return {
                    ...payload,
                    animationType: 'top',
                    // getMenuExpandMode(userDetails) === 'reports' ? `calc(100% - 311px)` : getMenuExpandMode(userDetails) === 'settings' ? `calc(100% - 232px)` : 'calc(100% - 63px)'
			        postitionProps: { top: `${6+stripHeight}px`, left: getMenuExpandMode(userDetails) === 'reports' ? `322px` : getMenuExpandMode(userDetails) === 'settings' ? `197px` : '71px'},
                    dimensions: { width: "62%", height: "70%", maxHeight: '620px', maxWidth: '870px', borderRadius: 5 },
                    userDetails : userDetails,
                    activeTab : activeTab,
                }
            }
            case "dataExportModal": {
                return {
                    ...payload,
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)', position: "absolute", margin: 0, borderRadius: 3 },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "78vw", height: "80vh", maxHeight: '800px', maxWidth: '1300px', borderRadius: 5 },
                    viewDataType: "table-view",
                    animationType: "bottom",
                    modalMainClass: "export-data-dropdown data-export-logs-modal",
                    // Label props
                    label: {
                        content: "Data Export",
                        rightComponent: () => {
                            return (
                                <GenericCustomButton sendEventAnalyticsToGoogle = {true} type='primary' label="View All" onClick={() => { history.push('/dataExportLogs');closeModal() }} />
                            )
                        }
                    },
                    headerKeys: {
                        "fileType": {
                            value: "File Type", // This can be a function also which can show the dynamic data
                        },
                        "fileName": {
                            value: "File Name", // This can be a function also which can show the dynamic data
                        },
                        "createdOn": {
                            value: "Created On", // This can be a function also which can show the dynamic data
                        },
                        "generatedOn": {
                            value: "Generated On", // This can be a function also which can show the dynamic data
                        },
                        "status": {
                            value: () => {
                                return (
                                    <div className='eddsc-refresh'>
                                        <LanguageTranslator tag='label'>Status</LanguageTranslator>
                                        <button type='button' className='hover:opacity-75' disabled={refreshListData} onClick={() => { setRefreshListData(true) }}><IconsPath.RefreshIcon /></button>
                                    </div>
                                )
                            }, // This can be a function also which can show the dynamic data
                            width: "20%" // This defines the width of the column
                        },
                        "downloadButton" : {
                            // value: "Download File"
                            value: () => {
                                return (
                                    <div> </div>
                                )
                            }
                        }
                    },
                    api: {
                        reduxState: "generalStore",
                        apiName: "getDataExportModal",
                        apiPayload: (params) => {
                            return {
                                "pageNo": params?.currentPage || 1,
                                "pageSize": 30,
                                "type": 1,
                                "search": "",
                                "filter": {},
                                "sortedBy": "",
                                "sortedIn": ""
                            }
                        },
                        apiExtraHeaders:  getPermissionKey("common", "commonFunctionality", "view"),
                        getMaxPage: (states, fucntions, response) => {
                            return response?.resource?.maxPage
                        },
                    },
                    itemKeys: {
                        // each header can have sevral item Keys
                        // "fileType": ["fileName"],
                        "fileType": [
                            (state, functions, data) => {
                                return <div className='fileName-field flex items-center justify-between gap-5'>
                                {/* <Tooltip overlayClassName="button-tooltip !p-[0]"
                                    overlayInnerStyle={{
                                        maxHeight: '300px',
                                        overflowY: 'auto',
                                        // backgroundColor: 'white',
                                        // color: 'black', 
                                        fontSize: '12px'
                                    }} 
                                    title={<p>{`${data.uuid}_${data.group_name}`}</p>}
                                    color='black'
                                >
                                    <span className='mdlr-multiple-row'>{`${data.uuid}_${data.group_name}`}</span>
                                    </Tooltip> */}
                                    
                                    <div className='relative group flex items-center gap-2'>
                                        <div><Icons.LogIcon/></div>
                                        <span className='mdlr-multiple-row'>{data?.fileName}</span>
                                    </div>
                                    {(data?.filter_condition && typeof JSON.parse(data.filter_condition) === 'object' && Object.keys(JSON.parse(data.filter_condition)).length > 0) && 
                                    <GenericCustomButton
                                        // type='default'
                                        leftIcon={<div className='relative'><div><Icons.GCFilterIcon height={17} width={17} className='!mr-[0]'/></div><div className='absolute top-[3px] right-[0px] p-[1px] bg-primary rounded-full'><Check color='white' strokeWidth={5} size={6} className='!mr-[0]' /></div></div>}
                                        tooltip='Open Filter Details'
                                        label={'Filtered'}
                                        size={'small'}
                                        className={'flex items-center gap-1.5 h-[26px] text-[11px] font-medium bg-primary_w_less_opacity rounded-[3px] text-fontBlack px-2 hover:opacity-75'}
                                        onClick={()=>{setOpenModal('appliedFilters'); setOpenModalData(data)}}
                                    />
                                    }
                                </div>;
                            },
                        ],
                        "fileName": [
                            (state, functions, data) => {
                                return <div className='fileName-field'>
                                <Tooltip overlayClassName="button-tooltip !p-[0]"
                                    overlayInnerStyle={{
                                        maxHeight: '300px',
                                        overflowY: 'auto',
                                        // backgroundColor: 'white',
                                        // color: 'black', 
                                        fontSize: '12px'
                                    }} 
                                    title={<p className='text-center'>{`${data.uuid}_${data.group_name}`}</p>}
                                    color='black'
                                >
                                    <span className='mdlr-multiple-row'>{`${data.uuid}_${data.group_name}`}</span>
                                </Tooltip>
                                </div>;
                            },
                        ],
                        "createdOn": ["creation_time"],
                        "generatedOn": ["updation_time"],
                        "status": [
                            (state, functions, data) => {
                                return renderDataExportModalStatus(state, functions, data);
                            },
                        ],
                        "downloadButton": [
                            (state, functions, data) => {
                                return data.status == "COMPLETED" &&
                                    <button onClick={handleChange("downloadExportDataFile", data)} className='p-[7px] rounded-[50%] duration-300 hover:bg-[#5d5fef1c]'>
                                    {/* <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }}>
                                        <path d="M1.875 11.875h11.25v1.25H1.875v-1.25zm6.25-3.643 3.794-3.794.884.883L7.5 10.625 2.197 5.322l.884-.885 3.794 3.794V1.25h1.25v6.982z" fill="#00CEB5" />
                                    </svg> */}
                                    <Icons.BlueDownloadIcon />
                                </button>
                            },
                        ]
                    },
                    getListData: (response) => {
                        return response?.resource?.data;
                    },
                    // renderCustomItems: {
                    //     "4": () => {
                    //         return (
                    //             <div className='edd-footer'>
                    //                 <button type='button' className='default-theme-btn'>View All</button>
                    //             </div>
                    //         )
                    //     }
                    // },
                    refreshData: refreshListData,
                }
            }
            case "trainingGuidesModal": {
                return {
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: {width: "450px", height: "100vh" },
                    animationType: "right",
                    closeModal: () => { setSelectedModal(""); setTrainingGuideSelectedFilter('all') },
                    parentModalMainClass: 'trainingGuideSidebar',
                    modalHeaderClassName: 'items-start',
                    // search props.
                    search: {
                        placeholder: "Type To Search here",
                        isSearchIconRequire: true,
                        customSearchFunction: (listState, listFunctions) => {
                            const { listData, currentSearch } = listState;
                            return listData?.filter(item => item?.displayName.toLowerCase().includes(currentSearch?.toLowerCase()));
                        },
                        searchInputClassName:'w-full placeholder:font-normal'
                    },
                    headerKeys: {
                        "displayName": {},
                    },
                    itemKeys: {
                        "displayName": ["displayName"]
                    },
                    rowRightComponent: <IconsPath.VendorRedirectIcon />,
                    label: ({
                        content: ()=>(
                            <div>
                                <LanguageTranslator tag='h2'>Training Guides</LanguageTranslator>
                                <LanguageTranslator tag='p' className='!font-normal'>Please find below a list of training guides uploaded to help you understand the usage and information of specific topics.</LanguageTranslator>
                            </div>
                        ),
                        closeModal: () => { setSelectedModal(""); setTrainingGuideSelectedFilter('all') }
                    }),
                    submitHandler: (data) => {
                        data?.fileUrl && window.open(data?.fileUrl);
                        setSelectedModal(false);
                        setTrainingGuideSelectedFilter('all');
                    },
                    getListData: (response) => {
                        let data = response?.resource;
                        return data?.filter(item => trainingGuideSelectedFilter=="all" ? true :  item?.fileType?.toString().toLowerCase() === trainingGuideSelectedFilter?.toLowerCase())
                    },
                    refreshData: `${trainingGuideCurrentTab}_${trainingGuideSelectedFilter}`,
                    isTrainingGuideModal: true,
                    renderCustomItems: {
                        "1": ({listDataCount}) => {
                            return (
                                <>
                                {tokenData?.uType?.toUpperCase() == "ENT" && <div className='border-t border-[#DAE4EE] mt-[12px]'>
                                    <GenericTabsComponent
                                        handleTabChange={(val) => setTrainingGuideCurrentTab(val)}
                                        current={trainingGuideCurrentTab}
                                        // type={1}
                                        tabsData={{
                                            ENT: "Retailer",
                                            VENDOR: 'Supplier',
                                            CUSTOMER: 'Customer'
                                        }}
                                    />
                                </div>
                                }
                                    <div className='text-[#575D6A] text-xs border-b border-[#DAE4EE] px-4 py-2 mb-2 flex items-center justify-between gap-3'>
                                        <p className='mb-0'><LanguageTranslator>Total Guides</LanguageTranslator> : <span className='text-[#575D6A] font-bold'>{listDataCount ?? ''}</span></p>
                                        <div ref={trainingGuideFilterDropdownRef} className="relative w-fit">
                                            <button
                                                onClick={() => setOpenFiltersDropdown(!openFiltersDropdown)}
                                                className="border border-[#E5E7EB] px-2 py-1 text-xs flex items-center gap-2 hover:border-primary_light hover:bg-primary_w_less_opacity"
                                            >
                                                <LanguageTranslator tag='p' className="mb-0 whitespace-nowrap text-[#67768E]">Sort by :</LanguageTranslator>
                                                <div className="flex items-center gap-2">
                                                    <LanguageTranslator tag='p' className="mb-0 font-medium text-fontBlack">{trainingGuideFilterDropdownData?.find(item => item?.value == trainingGuideSelectedFilter)?.label || ""}</LanguageTranslator>
                                                    <ChevronDown size={15} />
                                                </div>
                                            </button>
                                            
                                            <div className={`py-0.5 absolute top-[calc(100%+6px)] right-0 z-[4] w-fit bg-white font-normal flex flex-col shadow-xl border text-xs duration-200 ${openFiltersDropdown ? 'opacity-100 translate-y-0 visible pointer-events-auto' : 'opacity-0 -translate-y-2 invisible pointer-events-none'}`}>
                                                {trainingGuideFilterDropdownData.map((option) => (
                                                    <button
                                                        key={option.value}
                                                        onClick={() => {setTrainingGuideSelectedFilter(option.value); setOpenFiltersDropdown(false);}}
                                                        className="text-center whitespace-nowrap px-4 py-1.5 hover:bg-primary_w_less_opacity"
                                                    >
                                                        <LanguageTranslator>{option.label}</LanguageTranslator>
                                                    </button>
                                                ))}
                                            </div>
                                            
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    },
                    api: {
                        reduxState: "generalStore",
                        apiName: "getSupplymintTraningGuides",
                        apiPayload: (params) => {
                            return {
                                getBy : trainingGuideCurrentTab
                            }
                        },
                        getMaxPage: (states, fucntions, response) => {
                            return 1;
                        },
                    },
                }
            }
            case "notificationModal": {
                return {
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: { width: "35vw", height: "100vh" },
                    animationType: "right",
                    closeModal: () => { setSelectedModal("") }
                }
            }
            case "confirmationModal": {
                return {
                    ...payload,
                    // postitionProps: { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "50vw", height: "70vh", maxHeight: '580px', maxWidth: '730px'  },
                    animationType: "bottom",
                    // Label props
                    labelComponent: 'Are you sure to perform the action',
                    buttons: [{
                        label: 'Confirm', onClick: () => console.log('confirm button is clicked')
                    },
                    {
                        label: 'Cancled', onClick: () => console.log('Cancled button is clicked')

                    }],
                    message: 'Hello buddy',
                    icon: IconsPath.AdminIconMenuIcon
                }
            }
            case "escalationMatrixModal": {
                return {
                    ...payload,
                    postitionProps: { top: "10%", left: "10%", right: 0, borderRadius: 10 },
                    dimensions: { width: "80vw", minHeight: "40vh", height: 'fit-content' },
                    animationType: "top",
                }
            }
            case "replayAppTourModal": {
                return {
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: {width: "450px", height: "100vh" },
                    animationType: "right",
                    closeModal: () => { setSelectedModal("") },
                    parentModalMainClass: 'trainingGuideSidebar',
                }
            }
        }
    }

    const getInnerModalProps = () => {
        // let payload = {
        //     closeModal: closeModal
        // }
        switch (openModal) {
            case "appliedFilters": {
                return {
                    closeModal: () => { setOpenModal(null); setOpenModalData(false) },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: {width: "450px", height: "100vh" },
                    animationType: "right",
                    selectedData : openModalData
                }
            }
        }
    }

    const getInnerModalChildComponent = () => {
        switch (openModal) {
            case "appliedFilters": {
                return AppliedFiltersSidebarModal;
            }
        }
    }

    const renderDataExportModalStatus = (state, functions, data) => {
        return <div className='edd-status-col'>
            {/* <label className={`vso-status ${STATUS_CLASSNAME_MAP?.[data?.status] || ""}`} >{data?.status}
            </label> */}
            {data.status == "ERROR" ? <Tooltip overlayClassName="button-tooltip !p-[0]"
                overlayInnerStyle={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    // backgroundColor: 'white',
                    // color: 'black', 
                    fontSize: '12px'
                }} 
                title={data?.msg && <LanguageTranslator tag="p">{data?.msg}</LanguageTranslator>}
                color='black'
            >
                <LanguageTranslator tag="label" className={`vso-status ${STATUS_CLASSNAME_MAP?.[data?.status] || ""}`} >{data?.status}</LanguageTranslator>
            </Tooltip> : <LanguageTranslator tag="label" className={`vso-status ${STATUS_CLASSNAME_MAP?.[data?.status] || ""}`} >{data?.status}
            </LanguageTranslator>}
            {data.status === "IN-PROGRESS" &&
            <button className='edd-btn' onClick={handleChange("cancelItemExport", data)}>
                <IconsPath.DataExportCancelActiveIcon />
                <span className='generic-tooltip'>Cancel</span>
            </button>}
            {/* {data.status == "COMPLETED" &&
                <button onClick={handleChange("downloadExportDataFile", data)}>
                <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }}>
                    <path d="M1.875 11.875h11.25v1.25H1.875v-1.25zm6.25-3.643 3.794-3.794.884.883L7.5 10.625 2.197 5.322l.884-.885 3.794 3.794V1.25h1.25v6.982z" fill="#00CEB5" />
                </svg>
                <Icons.BlueDownloadIcon />
            </button>} */}
        </div>
    }

    return (
        <React.Fragment>
            <HeaderStrip loading={loading} setLoading= {setLoading} />

            <div className={`header-outer top-${stripHeight} ${props?.className}`}>
                <header 
                    className="header" 
                    id='mainHeaderSupplymint'
                    style={{
                        paddingLeft: getMenuExpandMode(userDetails) ? '' : '48px' 
                    }}
                >
                    {/* Render the div fild for the global search  */}
                    <div className="hoh-left" id='mainHeaderSupplymintSearch' >
                        <button className="hohl-global-search" onClick={handleChange("openGlobalSearchModal")}>
                            <IconsPath.GlobalSearchIcon />
                            <input autoComplete="off" type="text" readOnly value="" placeholder={`Page Search... `} />
                            <span className="short-key-btn"> {OS === "macOS" ? "\u2318" : "Ctrl"}+K</span>
                            {tokenData?.uType == "ENT" && <span className="short-key-btn ml-[5px]"> {OS === "macOS" ? "\u2318" : "Ctrl"}+Shift+K</span>}
                        </button>
                    </div>

                    {/* Render the new vendor registration here */}
                    {tokenData?.uType?.toUpperCase() == "VENDOR" && <NewRegisterVendorDashbaord type="header"/>}
        
                    {/* Render the right side section of the headers  */}
                    <div className="hoh-right" id='mainHeaderSupplymintProfile'>
                        {/* {tokenData?.uType?.toUpperCase() == "VENDOR" && <div 
                            className='px-2.5 py-1.5 mr-3 group h-[30px] flex items-center justify-center gap-2.5 border border-primary bg-primary_w_less_opacity text-primary rounded-[3px] cursor-pointer'
                            onClick={() => {
                                const hostname = window.location.hostname;

                                const baseUrl =
                                    (hostname === "localhost" || hostname === "quality.supplymint.com")
                                        ? "quality-vendor.supplymint.com"
                                        : "vendor.supplymint.com"

                                const token = sessionStorage.getItem("token");

                                const url = `https://${baseUrl}/#/?token=${encodeURIComponent(token || "")}`;

                                window.open(url, "_blank");
                            }}
                        >
                            <Sparkles size={16} className='shrink-0' />
                            <span className='text-xs font-medium'>Experience New Portal</span>
                            <div className='px-1.5 h-[18px] flex items-center justify-center text-xs font-medium bg-white rounded-[3px] border border-primary'>BETA</div>
                            <div className='h-[16px] aspect-square overflow-hidden'>
                                <Icons.ArrowPrimaryTopRight size={16} className='shrink-0 duration-200 group-hover:translate-y-[-16px] group-hover:translate-x-[16px]' />
                                <Icons.ArrowPrimaryTopRight size={16} className='shrink-0 duration-200 translate-x-[-16px] group-hover:translate-y-[-16px] group-hover:translate-x-[0]' />
                            </div>
                        </div>} */}
                        <UserDataMappingCheck history={history} />
                        <ul className="hohr-menu">
                            {/* {window.location.hostname !== "prod.supplymint.com" && <li>
                                <LanguageChooserComponent currentLanguage={c urrentLanguage} setCurrentLanguage={setCurrentLanguage} setSelectedModal={setSelectedModal} timer={timer} dropdownType = {2}/>
                            </li>} */}
                            {/* Render the help section */}
                            {tokenData?.loginSource?.toUpperCase() == "SELF" && <li id="headerHelp" onClick={handleChange("helpAndSupportDropdown")} className="hohrm-list hohrm-btn-v2">
                                <IconsPath.HeaderHelpMenuIcon />
                                <LanguageTranslator tag="span" class="generic-tooltip">Help</LanguageTranslator>
                            </li>}
                            {/* Render the Help & Support Dropdown Modal here */}
                            {helpAndSupportDropdown && <HelpAndSupportDropdownComponent
                                setSelectedModal={setSelectedModal}
                                closeHelpModal={() => closeHelpModal()}
                                createNewTicket={props.createNewTicket}
                                helpAndTrainingConfig = {helpAndTrainingConfig || []}
                            />}
                            <li className="hohrm-list hohrm-btn" id="headerExcelUpload" onClick={() => history.push('/excel-upload')}>
                                <IconsPath.UploadExcelIcon />
                                <LanguageTranslator tag ="span" className={`generic-tooltip`}>Upload Excel</LanguageTranslator>
                            </li>
                            {tokenData?.uType?.toUpperCase() === "ENT" && <li className="hohrm-list hohrm-btn" id="headerApiMonitor" onClick={() => history.push('/data-api-monitor')}>
                                <IconsPath.FileCodeCorner />
                                <LanguageTranslator tag="span" className="generic-tooltip">API Monitoring</LanguageTranslator>
                            </li>}
                            <li className="hohrm-list hohrm-btn" id="headerDataExport" onClick={handleChange("openDataExportModal")}><IconsPath.HeaderDataExportIcon />
                                <LanguageTranslator tag="span" class="generic-tooltip">Data Export</LanguageTranslator>
                            </li>
                            <li className="hohrm-list hohrm-btn" id="headerTaskManager" onClick={() => history.push('/task-manager')}>
                                <ListChecks size={20} />
                                <LanguageTranslator tag="span" class="generic-tooltip">Task Manager</LanguageTranslator>
                            </li>
                            {tokenData?.loginSource?.toUpperCase() == "SELF" && <li id="headerNotification" className="hohrm-list hohrm-btn" onClick={() => {sendButtonClickEventToGoogleAnalytics({
                                label: "Notifications", location : location,
                            });  setSelectedModal("notificationModal") }}><IconsPath.HeaderNotificationsIcon />
                                <LanguageTranslator tag="span" class="generic-tooltip">Notifications</LanguageTranslator>
                            </li>}
                            <li className='hohrm-list p-rgt-0' id="headerProfileSection">
                                {/* Render the profile section here. */}
                                <ProfileSection {...props} loading={loading} setLoading= {setLoading} />
                            </li>
                        </ul>


                    </div>
                </header>
            </div>

            <React.Fragment>
                {/* Render the Paren Modal to render all the modal components here */}
                {selectedModal && <ParentModal
                    getParentChildProps={getParentChildProps()}
                    childComponent={getChildComponent()}
                    closeModal={() => { setSelectedModal(false) }}
                />}

                {openModal && <ParentModal
                    getParentChildProps={getInnerModalProps()}
                    childComponent={getInnerModalChildComponent()}
                    closeModal={() => { setOpenModal(false) }}
                />}

            </React.Fragment>
            {/* Set Loading to true and show the full page loader */}
            {loading && <>
                <FullPageLoader />
            </>}
        </React.Fragment>
    )
}

export default SupplymintHeader